import { useAdManager, useAdManagerNavigation, useShowSpinner } from 'hooks';
import { useMemo, useState } from 'react';
import type { FBTableTabs } from 'types/fbTable';
import FacebookTableView from './FacebookTable.View';

const FacebookTableContainer = () => {
  const { getCampaigns, getAdSets, getAds } = useAdManager();
  const [tab, setTab] = useState<FBTableTabs>('campaigns');

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome migration; the app is already working as expected with these dependency arrays
  const getMethods = useMemo(
    () => ({
      ads: getAds,
      adsets: getAdSets,
      campaigns: getCampaigns
    }),
    []
  );

  const {
    ads,
    adsets,
    campaigns,
    dateRange,
    lastUpdate,
    loaded,
    loading,
    onDateRangeChange,
    onPaginateNext,
    onPaginatePrevious,
    onRowSelect,
    metaAdAccount,
    onSelectAdAccount,
    pages
  } = useAdManagerNavigation(tab, getMethods);

  useShowSpinner({ show: loading });

  const data = {
    campaigns,
    adsets,
    ads
  };

  const { hasNext, hasPrevious } = pages[tab];

  return (
    <FacebookTableView
      metaAdAccount={metaAdAccount}
      loading={loaded && loading}
      initialLoading={!loaded}
      lastUpdate={lastUpdate}
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
      onSelectAdAccount={onSelectAdAccount}
      tab={tab}
      onRowSelect={onRowSelect}
      onTabClick={setTab}
      campaigns={data.campaigns}
      adsets={data.adsets}
      ads={data.ads}
      onNext={hasNext ? () => onPaginateNext(tab) : undefined}
      onPrevious={hasPrevious ? () => onPaginatePrevious(tab) : undefined}
    />
  );
};

export default FacebookTableContainer;
